import { styled, Box } from "@mui/material";

export const SelectionWrapper =  styled(Box)({
    position: "absolute",
    pointerEvents: "none",
    zIndex: 5,
});